const AppLoadingState = ({
  title = "Chargement en cours",
  description = "Veuillez patienter quelques instants.",
  testId,
  compact = false,
}) => (
  <section
    className={`rounded-3xl border border-white/10 glass p-6 ${compact ? "min-h-40" : "min-h-56"}`}
    data-testid={testId}
  >
    <div className="flex h-full flex-col items-center justify-center gap-4 text-center">
      <div className="h-8 w-8 rounded-full border-2 border-lenvia-blue border-t-transparent animate-spin" />
      <div>
        <p className="text-sm font-semibold text-white">{title}</p>
        <p className="mt-1 text-sm text-slate-400">{description}</p>
      </div>
    </div>
  </section>
);

export default AppLoadingState;
